export default {
      id: "arrow-back-usage",
      viewBox: "0 0 13 21",
      url: __webpack_public_path__ + "img/icons.a12b6041.svg#arrow-back",
      toString: function () {
        return this.url;
      }
    }